import App from '@components/products/App.vue'
import { generateApplication } from '@helpers/generate_component.js';
import { generateAxiosInstance } from '@helpers/axios_provider.js'

import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';

generateApplication(
    App,
    "#app",
    {
        injections: [{
            name: 'axios', module: generateAxiosInstance(hostApiKey, '/api/v1/pub/')
        }, {
            name: 'locale', module: locale
        }, {
            name: 'translations', module: translations
        }],
        components: [
            { name: 'vSelect', module: vSelect }
        ]
    }
)